import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { getApi } from '../../../../../services/api';
import { databaseManagement } from '../../../../../services/endpoints';
import { DbMapItem } from '../index';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  item: DbMapItem;
  onSuccess: () => void;
};

const DeleteDbMapModal = ({ showModal, closeModal, item, onSuccess }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);

    try {
      const api = await getApi();
      const res = await api.delete(databaseManagement['/db-map'], {
        data: {
          table: item.table,
          column: item.column,
          reference: item.reference,
        },
      });

      if (res.status === HttpStatus.OK) {
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        closeModal();
        onSuccess();
      } else {
        throw res;
      }
    } catch (err) {
      backendErrorNotification(err as AxiosError<any, any>);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      title={`${t('delete')} ${t('dbMap')}`}
      showModal={showModal}
      closeModal={closeModal}
      action={handleDelete}
      actionNameBtn={t('delete')}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <p>
              {`${t('deleteSure')}?`}
              <br />
              <br />
              <b>{t('table')}:</b> {item.table}
              <br />
              <b>{t('column')}:</b> {item.column}
              <br />
              <b>{t('reference')}:</b> {item.reference}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDbMapModal;
